import React,{useState} from 'react';
import envConfig from '../../config/env';

function ImgUpload(props){
    const [ShowImageTool,setShowImageTool]=useState(false);
    const [ShowImageTip,setShowImageTip]=useState('');
    let NewFileName='';
    let FileExtension='';
    let NoFileExtension='';
    const SetNewFileName=(fileName)=>{     
         FileExtension=(/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : ''; 
         NoFileExtension=fileName.replace(FileExtension,'');
          /*拿掉空白*/
          NewFileName=NoFileExtension.replace(/[%+#=& ]+/g,'')+FileExtension;
          //console.log('NewFileName='+NewFileName);
    }
    const handleFileUpload = (name, stateName, uploadName, parentObj) => event =>{
        const infoArea = document.getElementById(name);
        const input = event.target;   
        setShowImageTip('image處理中...')
        if (input.files && input.files[0]) {
            const file = event.target.files[0];          

            if(props.limitType && props.limitType.length > 0){
                if(file.type.indexOf(props.limitType) < 0){
                    alert('請上傳正確的圖片格式: ' + props.limitType );
                    setShowImageTip('請上傳正確的圖片格式: ' + props.limitType)
                    return;
                }
            }
            /* 檢測檔名有無非法字元 不算完成 這是測試版 */
            let FileExtension=(/[.]/.exec(file.name)) ? /[^.]+$/.exec(file.name)[0] : ''; 
            //console.log(FileExtension);
            let NoFileExtension=file.name.replace(FileExtension,'');
            if( /[\\/?:*"><|]+/g.test(NoFileExtension)){
                alert('檔名不允許字元 \\ / ? : * " > < | 請檢查!!');
                setShowImageTip('檔名不允許字元 \\ / ? : * " > < | 請檢查!!');
                return;
            }           

            if(file.type.indexOf('jpeg') < 0 && file.type.indexOf('png') < 0 ){
                alert('請上傳圖片檔案');
                setShowImageTip('請上傳圖片檔案')
                return;
            }          
            let ImageType = file.type;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                
                const img = new Image();
                const that = parentObj;
                img.src=reader.result;
                //console.log(reader.result)

                img.onload = function() {
                   if(img.width > props.imgW || img.height > props.imgH ||(img.width < props.imgW && img.height < props.imgH)){
                       //    alert('上傳圖片尺寸不合');
                       //    return false;  
                       // 這裡需要一個標配處理功能    
                       ImageDefault(img,file,stateName,uploadName,infoArea,that,ImageType);  
                              
                   }
                   else{
                        that.setState( {...that.state,
                            [uploadName]: {
                                file: URL.createObjectURL(file),
                                value : reader.result
                            }
                        });
                        //console.log('reader.result:'+reader.result);
                        SetNewFileName(file.name);
                        infoArea.textContent = '上傳檔案名稱: ' + NewFileName;
                        const fileFullName = stateName + "_"+ NewFileName;
                        that.setState({ ...that.state, [stateName]: fileFullName });
                        setShowImageTip('');
                        //setShowImageTool(false)
                   }
                   setShowImageTool(true);   
                };           
            };
        }else{
            setShowImageTip('');
        }      
    }

    const ImageDefault=(img,file,stateName,uploadName,infoArea,that,ImageType)=>{
       
            let workCan = document.createElement("canvas");
            // set the canvas resolution to the cropped image size
            workCan.width = Math.floor(props.imgW);
            workCan.height = Math.floor(props.imgH);
            let ctx = workCan.getContext("2d");
            let scale = Math.min(workCan.width / img.width, workCan.height / img.height);
            //console.log('scale='+scale);
            //擺放位置，置中計算
            let x = 0;
            let y = 0;
            //縮放圖
            let imgWidth = img.width * scale;
            let imgHeight = img.height * scale;
             //canvas 不重新定義，縮圖會在正中間，兩側會有大大白底
             if (img.width > props.imgW || img.height > props.imgH) {
                 x = (workCan.width - imgWidth)/2;
                 y = (workCan.height- imgHeight)/2;
                // console.log('1.(x,y)='+x+','+y);
             }
             if (img.width <= props.imgW && img.height <= props.imgH) {
                x = (workCan.width -imgWidth) / 2 ;
                y = (workCan.height-imgHeight) / 2 ;
                //console.log('2.(x,y)='+x+','+y)
             }           
             ctx.drawImage(img, x, y, imgWidth, imgHeight);
            //白背景結合縮放圖  
            ctx.globalCompositeOperation = 'destination-over';      
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, workCan.width,workCan.height); 
                 

            let dataURL = workCan.toDataURL('image/jpg');
            // console.log('dataURL:'+dataURL);
            let blobBin = atob(dataURL.split(',')[1])
            let array = []
            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }
            let newFile = new Blob([new Uint8Array(array)], {
                type: ImageType
            });

            that.setState({
                ...that.state,
                [uploadName]: {
                    file: URL.createObjectURL(newFile),
                    value: dataURL
                }
            });
            SetNewFileName(file.name);
            infoArea.textContent = '上傳檔案名稱: ' + NewFileName;
            const fileFullName = stateName + "_" + NewFileName;
            that.setState({ ...that.state, [stateName]: fileFullName });
            setShowImageTip('影像處理：自動縮放至合適尺寸，不足處將以白底自動填充到指定圖片尺寸。')
    }

    const ImageScaleToFitNoWhite = (name, stateName, uploadName, parentObj) => {
        const infoArea = document.getElementById(name);
        const file = document.getElementById(uploadName).files[0];

        //const fileSize=file.size;
        //console.log("ImageScaleToFitNoWhite："+fileSize)
        let ImageType = file.type;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {

            const img = new Image();
            const that = parentObj;
            img.src = reader.result;

            img.onload = function () {
               
                
                    let workCan = document.createElement("canvas");
                    // set the canvas resolution to the cropped image size
                    workCan.width = Math.floor(props.imgW);
                    workCan.height = Math.floor(props.imgH);
                    let ctx = workCan.getContext("2d");
                    //let scale=Math.min(workCan.width / img.width, workCan.height / img.height);
                    let scaleWidth =(workCan.width / img.width); 
                    let scaleHeight =(workCan.height / img.height); 
                    //console.log('ImageScaleToFitNoWhite-scaleWidth：'+scaleWidth)
                    //寬度縮放圖
                    let imgWidth=img.width;
                    let imgHeight=img.height;                   
                     imgWidth= img.width * scaleWidth; 
                     imgHeight= img.height * scaleHeight;
                     workCan.width = imgWidth;
                     workCan.height = imgHeight;
                    //canvas和圖片一樣大
                    ctx.drawImage(img, 0, 0, imgWidth, imgHeight);                   
                   

                    let dataURL = workCan.toDataURL(ImageType);
                    // console.log('dataURL:'+dataURL);
                    let blobBin = atob(dataURL.split(',')[1])
                    let array = [];
                    for (let i = 0; i < blobBin.length; i++) {
                        array.push(blobBin.charCodeAt(i));
                    }
                    let newFile = new Blob([new Uint8Array(array)], {
                        type: ImageType
                    });

                    that.setState({
                        ...that.state,
                        [uploadName]: {
                            file: URL.createObjectURL(newFile),
                            value: dataURL
                        }
                    });
                    SetNewFileName(file.name);
                    infoArea.textContent = '上傳檔案名稱: ' + NewFileName;
                    const fileFullName = stateName + "_" +NewFileName;
                    that.setState({
                        ...that.state,
                        [stateName]: fileFullName
                    });
              
                    setShowImageTip('影像處理：非等比例，寬高依據指定尺寸，各自處理到指定大小。')
            }
        }
    }

    const ImageScaleToFit = (name, stateName, uploadName, parentObj) => {
        const infoArea = document.getElementById(name);
        const file = document.getElementById(uploadName).files[0];
        //const fileSize=file.size;
        //console.log("ImageScaleToFit:"+fileSize);
        let ImageType = file.type;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const img = new Image();
            const that = parentObj;
            img.src = reader.result;

            img.onload = function () {
                ImageDefault(img,file,stateName,uploadName,infoArea,that,ImageType);
            }

        }
    }

    const handleImageScaleToFitNoWhite = (name, stateName, uploadName, parentObj) => event =>{
        setShowImageTip('image處理中...')
        ImageScaleToFitNoWhite(name, stateName, uploadName, parentObj,event);
    }

    const handleImageScaleToFit = (name, stateName, uploadName, parentObj) => event =>{
        setShowImageTip('image處理中...')
        ImageScaleToFit(name, stateName, uploadName, parentObj,event);
   }


    return(

       <div className="container align">
            <div className="form-row">
                <label>
                    { props.required &&
                        <span className='text-danger'>*</span>
                    }
                    {props.title}
                </label>
                <em className='text-primary'>{props.notice}<br/>{props.notice2}</em><span className="text-danger"> 檔名不允許字元 \ / ? : * &quot; &gt; &lt; | </span> 
            </div>
            <div className="form-row">
                <div className="card image-area mt-4 overflow">
                    <img id={`${props.objName}_Result`} src={props.imgUpload} alt="For Upload" className="img-fluid rounded shadow-sm mx-auto d-block inner" />
                    {ShowImageTip !=='' && <span> {ShowImageTip} </span>}
                   
                </div>
                {ShowImageTool===true 
                     && <div className="pr-1">
                    <button type="button" className="btn btn-outline-primary" onClick={handleImageScaleToFitNoWhite(`${props.objName}Upload-label`, props.objName,`${props.objName}Upload`, props.parentObj)}>{envConfig.ImageFitNoWhite}</button>
                    <button type="button" className="btn btn-outline-primary" onClick={handleImageScaleToFit(`${props.objName}Upload-label`, props.objName,`${props.objName}Upload`, props.parentObj)}>{envConfig.ImageFit}</button>
                    </div>}
                <div className="input-group mb-3 px-2 py-2 rounded-pill bg-white shadow-sm">
                    <input type="hidden" id={`${props.objName}`} value={props.imgFileName} />
                     
                    <input id={`${props.objName}Upload`} type="file"  accept="image/*" onChange={handleFileUpload(`${props.objName}Upload-label`, props.objName,`${props.objName}Upload`, props.parentObj)} className="form-control border-0 uploadFile" />
                    <label id={`${props.objName}Upload-label`} htmlFor="upload" className="font-weight-light text-muted upload-label">選擇檔案</label>
                   
                    <div className="input-group-append">
                        <label htmlFor={`${props.objName}Upload`} className="btn btn-light m-0 rounded-pill px-4"> <i className="fa fa-cloud-upload mr-2 text-muted"></i>
                        <small className="text-uppercase font-weight-bold text-muted">選擇檔案</small></label>
                    </div>
                </div>
              
                
            </div>
        </div>

    )

    
}

export default ImgUpload;